module.exports = __webpack_public_path__ + "img/TV_android-series_W800G.06934aa4.png";